export default {
	tracking: {
		adobeAnalytics: {
			local: '096a4e5b7733/launch-e83e13f09315-staging',
			dev: '096a4e5b7733/launch-e83e13f09315-staging',
			stage: '096a4e5b7733/launch-e83e13f09315-staging',
			prod: '096a4e5b7733/launch-0d24248860c6',
			scode: {
				local: 'content/dam/norton-adobe-analytics/test/s_code_norton_min_preview.js',
				dev: 'content/dam/norton-adobe-analytics/test/s_code_norton_min_preview.js',
				stage: 'content/dam/norton-adobe-analytics/test/s_code_norton_min_preview.js',
				prod: 'content/dam/norton-adobe-analytics/prod/s_code_norton_min.js'
			}
		},
		gtm: 'GTM-WZLVDCV',
		gtmSDL: 'GTM-WPC6R3K',
		platform: 'web'
	},
	providers: {
		gen: {
			isDefaultProvider: true,
			name: 'gen',
			brand: 'AVAST',
			pp: 'GENAPI',
			project: 'genavast',
			hppVendorId: 'hpp_avastco'
		}
	},
	variables: {
		createAccount: true,
		useAuthenticatedFlow: true,
		useBrazilianFlow: false, // Different form + extra step: "paymentDetails" page
		supportPhone: '+1&nbsp;855&#8209;745&#8209;3255',
		defaultSupportPhone: '+1&nbsp;855&#8209;745&#8209;3255',
		displayPhoneNumber: 'off', // options: ['off', 'always', 'attribute']. 'off'- hidden, 'always' - always visible, 'attribute'- requires displayPhoneNumber attribute
		displayAddressField: false, // Display address on order page
		disableCountrySelector: false, // Disable country selection and geo detection
		hasTermsCheckbox: false, // Force to display T&Cs checkbox
		hasPricesInTerms: false, // Show prices in T&Cs
		hasYearNote: false, // Show the "/year" or "/first X years" note in the sidebar
		hasOfferModal: true,
		hasDisclaimer: false, // show the auto-renewal disclaimer only for locales which require it
		hasFuturePrice: false, // show future prices only for locales which require it
		hasQrPayment: false, // show QR code on thank you page
		isRtl: false // set the cart as right-to-left
	},
	locales: {
		ar: {
			ww: {
				isDefaultRegion: true,
				fallbackCountry: 'EG',
				providers: {
					gen: {
						locale: 'en_EG',
						policyLocale: 'ar_WW',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: false,
					policyLocale: 'ar-ww',
					isRtl: true
				},
				localization: {}
			},
			sa: {
				providers: {
					gen: {
						locale: 'en_SA',
						policyLocale: 'ar_WW',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: false,
					policyLocale: 'ar-ww',
					isRtl: true
				},
				localization: {}
			},
			ae: {
				providers: {
					gen: {
						locale: 'en_AE',
						policyLocale: 'ar_WW',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true,
					policyLocale: 'ar-ww',
					isRtl: true
				},
				localization: {}
			}
		},
		cs: {
			cz: {
				isDefaultRegion: true,
				providers: {
					gen: {
						locale: 'cs_CZ',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'wireTransfer',
							isEnabled: false
						}]
					}
				},
				variables: {
					hasAccountNumber: true,
					hasBankCode: true,
					hasQrPayment: true,
					isTaxIncluded: true
				},
				localization: {}
			},
			sk: {
				providers: {
					gen: {
						locale: 'sk_SK',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}, {
							id: 'wireTransfer',
							isEnabled: false
						}]
					}
				},
				variables: {
					isTaxIncluded: true,
					policyLocale: 'cs-sk'
				},
				localization: {}
			}
		},
		da: {
			dk: {
				isDefaultRegion: true,
				providers: {
					gen: {
						locale: 'da_DK',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			}
		},
		de: {
			at: {
				providers: {
					gen: {
						locale: 'de_AT',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}, {
							id: 'directDebit',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			},
			ch: {
				providers: {
					gen: {
						locale: 'de_CH',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			},
			de: {
				isDefaultRegion: true,
				providers: {
					gen: {
						locale: 'de_DE',
						paymentMethods: [{
							id: 'payPalBilling',
							isEnabled: true
						}, {
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'sofort',
							isEnabled: true
						}, {
							id: 'directDebit',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true,
					supportPhone: '(+49)&nbsp;800&nbsp;724&nbsp;4240'
				},
				localization: {}
			}
		},
		el: {
			gr: {
				isDefaultRegion: true,
				providers: {
					gen: {
						locale: 'el_GR',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			}
		},
		en: {
			ww: {
				isDefaultRegion: true,
				isDefaultLanguage: true,
				fallbackCountry: 'IL',
				providers: {
					gen: {
						locale: 'en_US',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: false,
					supportPhone: '+1&nbsp;855&#8209;745&#8209;3255'
				},
				localization: {}
			},
			ae: {
				providers: {
					gen: {
						locale: 'en_AE',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: false,
					supportPhone: '+1&nbsp;855&#8209;745&#8209;3255'
				},
				localization: {}
			},
			au: {
				providers: {
					gen: {
						locale: 'en_AU',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true,
					supportPhone: '+611&nbsp;800&nbsp;673&nbsp;935',
					displayPhoneNumber: 'attribute'
				},
				localization: {}
			},
			ca: {
				providers: {
					gen: {
						locale: 'en_CA',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: false,
					supportPhone: '+1&nbsp;855&#8209;745&#8209;3255',
					displayPhoneNumber: 'attribute'
				},
				localization: {}
			},
			eu: {
				fallbackCountry: 'IE',
				providers: {
					gen: {
						locale: 'en_IE',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true,
					supportPhone: '+44&nbsp;800&nbsp;048&nbsp;8941'
				},
				localization: {}
			},
			gb: {
				providers: {
					gen: {
						locale: 'en_GB',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true,
					supportPhone: '800&#8209;048&#8209;8941',
					displayPhoneNumber: 'attribute',
					hasDisclaimer: true,
					hasFuturePrice: true
				},
				localization: {}
			},
			id: {
				providers: {
					gen: {
						locale: 'en_ID',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: false
				},
				localization: {}
			},
			ie: {
				providers: {
					gen: {
						locale: 'en_IE',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}, {
							id: 'directDebit',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true,
					supportPhone: '+44&nbsp;800&nbsp;048&nbsp;8941'
				},
				localization: {}
			},
			in: {
				providers: {
					gen: {
						locale: 'en_IN',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true,
					displayPhoneNumber: 'always',
					displayAddressField: true
				},
				localization: {}
			},
			my: {
				providers: {
					gen: {
						locale: 'en_MY',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			},
			nz: {
				providers: {
					gen: {
						locale: 'en_NZ',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true,
					supportPhone: '+611&nbsp;800&nbsp;673&nbsp;935'
				},
				localization: {}
			},
			ph: {
				providers: {
					gen: {
						locale: 'en_PH',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			},
			sg: {
				providers: {
					gen: {
						locale: 'en_SG',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: false
				},
				localization: {}
			},
			us: {
				providers: {
					gen: {
						locale: 'en_US',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: false,
					supportPhone: '+1&nbsp;855&#8209;745&#8209;3255',
					displayPhoneNumber: 'attribute',
					hasTermsCheckbox: true,
					hasPricesInTerms: true,
					hasYearNote: true
				},
				localization: {}
			},
			za: {
				providers: {
					gen: {
						locale: 'en_ZA',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			}
		},
		es: {
			ar: {
				providers: {
					gen: {
						locale: 'es_AR',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: false
				},
				localization: {}
			},
			cl: {
				providers: {
					gen: {
						locale: 'es_CL',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			},
			co: {
				providers: {
					gen: {
						locale: 'es_CO',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: false
				},
				localization: {}
			},
			es: {
				providers: {
					gen: {
						locale: 'es_ES',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}, {
							id: 'directDebit',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			},
			mx: {
				providers: {
					gen: {
						locale: 'es_MX',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: false
				},
				localization: {}
			},
			ni: {
				fallbackCountry: 'MX',
				providers: {
					gen: {
						locale: 'es_NI',
						policyLocale: 'es_WW',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: false,
					policyLocale: 'es-ww'
				},
				localization: {}
			},
			pe: {
				providers: {
					gen: {
						locale: 'es_PE',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: false,
					policyLocale: 'es-ww'
				},
				localization: {}
			},
			ww: {
				isDefaultRegion: true,
				fallbackCountry: 'IE',
				providers: {
					gen: {
						locale: 'es_NI',
						policyLocale: 'es_WW',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: false,
					policyLocale: 'es-ww'
				},
				localization: {}
			}
		},
		fi: {
			fi: {
				isDefaultRegion: true,
				providers: {
					gen: {
						locale: 'fi_FI',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}, {
							id: 'directDebit',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			}
		},
		fr: {
			be: {
				providers: {
					gen: {
						locale: 'fr_BE',
						paymentMethods: [{
							id: 'payconiq',
							isEnabled: true
						}, {
							id: 'bancontact',
							isEnabled: true
						}, {
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}, {
							id: 'directDebit',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			},
			ca: {
				providers: {
					gen: {
						locale: 'fr_CA',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: false
				},
				localization: {}
			},
			ch: {
				providers: {
					gen: {
						locale: 'fr_CH',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			},
			fr: {
				isDefaultRegion: true,
				providers: {
					gen: {
						locale: 'fr_FR',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}, {
							id: 'directDebit',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true,
					supportPhone: '+33&nbsp;805&nbsp;543&nbsp;957'
				},
				localization: {}
			}
		},
		hu: {
			hu: {
				isDefaultRegion: true,
				providers: {
					gen: {
						locale: 'hu_HU',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			}
		},
		it: {
			it: {
				isDefaultRegion: true,
				providers: {
					gen: {
						locale: 'it_IT',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}, {
							id: 'directDebit',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			},
			ch: {
				providers: {
					gen: {
						locale: 'it_CH',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true,
					policyLocale: 'it-it'
				},
				localization: {}
			}
		},
		iw: {
			il: {
				isDefaultRegion: true,
				providers: {
					gen: {
						locale: 'en_IL',
						policyLocale: 'he_IL',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: false,
					policyLocale: 'he-il',
					isRtl: true
				},
				localization: {}
			}
		},
		ja: {
			jp: {
				isDefaultRegion: true,
				providers: {
					gen: {
						locale: 'ja_JP',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true,
					supportPhone: '03&#8209;4233&#8209;9356'
				},
				localization: {}
			}
		},
		ko: {
			kr: {
				isDefaultRegion: true,
				providers: {
					gen: {
						locale: 'ko_KR',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			}
		},
		nl: {
			be: {
				providers: {
					gen: {
						locale: 'nl_BE',
						paymentMethods: [{
							id: 'payconiq',
							isEnabled: true
						}, {
							id: 'bancontact',
							isEnabled: true
						}, {
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}, {
							id: 'directDebit',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			},
			nl: {
				isDefaultRegion: true,
				providers: {
					gen: {
						locale: 'nl_NL',
						paymentMethods: [{
							id: 'iDeal',
							isEnabled: true
						}, {
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}, {
							id: 'directDebit',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			}
		},
		no: {
			no: {
				isDefaultRegion: true,
				providers: {
					gen: {
						locale: 'no_NO',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			}
		},
		pl: {
			pl: {
				isDefaultRegion: true,
				providers: {
					gen: {
						locale: 'pl_PL',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}, {
							id: 'wireTransfer',
							isEnabled: false
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			}
		},
		pt: {
			pt: {
				isDefaultRegion: true,
				providers: {
					gen: {
						locale: 'pt_PT',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}, {
							id: 'directDebit',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true,
					supportPhone: '0800&nbsp;891&nbsp;2833'
				},
				localization: {}
			},
			br: {
				providers: {
					gen: {
						locale: 'pt_BR',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'boleto',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true,
					useAuthenticatedFlow: false,
					useBrazilianFlow: true,
					disableCountrySelector: true
				},
				localization: {}
			}
		},
		ro: {
			ro: {
				providers: {
					gen: {
						locale: 'ro_RO',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			}
		},
		sk: {
			sk: {
				isDefaultRegion: true,
				providers: {
					gen: {
						locale: 'sk_SK',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}, {
							id: 'wireTransfer',
							isEnabled: false
						}]
					}
				},
				variables: {
					isTaxIncluded: true,
					policyLocale: 'cs-sk'
				},
				localization: {}
			}
		},
		sv: {
			se: {
				isDefaultRegion: true,
				providers: {
					gen: {
						locale: 'sv_SE',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			}
		},
		th: {
			th: {
				isDefaultRegion: true,
				providers: {
					gen: {
						locale: 'th_TH',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			}
		},
		tr: {
			tr: {
				isDefaultRegion: true,
				providers: {
					gen: {
						locale: 'tr_TR',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			}
		},
		zh: {
			tw: {
				isDefaultRegion: true,
				providers: {
					gen: {
						locale: 'zh_TW',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}, {
							id: 'payPalBilling',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: true
				},
				localization: {}
			},
			cn: {
				providers: {
					gen: {
						locale: 'zh_CN',
						paymentMethods: [{
							id: 'creditCard',
							isEnabled: true
						}]
					}
				},
				variables: {
					isTaxIncluded: false
				},
				localization: {}
			}
		}
	}
};
